<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" right="iconadd" :back-level="1000" @rightClick="onGotoList" />
    <div class="dataRect">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="newRect" @click="onGotoList">
          <i class="iconfont iconadd" />购买潜水保险
          <div class="remark">保障潜水旅行 安潜</div>
        </div>
        <div v-for="item in list" :key="item.insuranceOrderId" class="dataLine" @click="onSelectItem(item.insuranceOrderId)">
          <div class="imgs">
            <van-image
              width="6em"
              height="5.5em"
              lazy-load
              fit="cover"
              :src="item.image"
            />
            <div class="price" :style="'color:'+GetColorMainBack()"><span>￥</span>{{ ShowMoneySpan(item.payAmount*0.01,true) }}.<span>{{ ShowMoneySpan(item.payAmount*0.01,false) }}</span></div>
          </div>
          <div class="body">
            <div class="remark"><span>产品:</span>{{ item.productName }}</div>
            <div class="remark"><span>保障期限:</span>{{ formatDate(item.startDate,"yyyy-MM-dd") }} 至 {{ formatDate(item.endDate,"yyyy-MM-dd") }}</div>
            <div class="remark"><span>被保险人:</span>{{ item.insurantsName }}</div>
            <div class="tags">
              <template v-if="item.payStatus==='Pay'||item.payStatus==='DeductionSuccess'">
                <van-tag type="danger" :color="GetColorMainBack()">{{ GetEnumText('Em_EffectiveStatus',item.effectiveStatus) }}</van-tag>
                <van-tag type="danger" :color="GetColorMainBack()">{{ GetEnumText('Em_IssueStatus',item.issueStatus) }}</van-tag>
              </template>
              <template v-else>
                <van-tag type="danger" :color="GetColorMainBack()">{{ GetEnumText('Em_InsurancePayStatus',item.payStatus) }}</van-tag>
                <!-- <van-tag type="danger" :color="GetColorMainBack()">{{ GetEnumText('Em_EffectiveStatus',item.effectiveStatus) }}</van-tag>
                <van-tag type="danger" :color="GetColorMainBack()">{{ GetEnumText('Em_IssueStatus',item.issueStatus) }}</van-tag> -->
              </template>
            </div>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Image, Lazyload, List, Tag } from 'vant'
import TopBar from '@/components/TopBar'
import { ShowMoneySpan, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Image.name]: Image,
    [Lazyload.name]: Lazyload,
    [List.name]: List,
    [Tag.name]: Tag,
    TopBar
  },
  data() {
    return {
      titleTop: '',
      title: '我的保险列表',
      backurl: '/my/index',
      search: {
        limit: 30,
        page: 1
      },
      loading: undefined,
      finished: false,
      list: []
    }
  },

  created() {
    this.titleTop = GetSysTitle()
  },
  methods: {
    ShowMoneySpan,
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    onGotoList() {
      this.$router.push('/insurance/list')
    },
    onSelectItem(id) {
      this.$router.push('/insurance/myInfo/' + id)
    },
    onSearch() {
      console.log('onSearch', this.search)
      this.init()
    },
    init() {
      this.list = []
      this.search.page = 1
      this.finished = false
      this.onLoad()
    },
    onLoad() {
      console.log('onLoad')
      if (this.loading === undefined) {
        this.loading = true
        return
      }
      this.loading = true
      request({
        url: '/Insurance/GetUserInsuranceOrderList',
        method: 'post',
        data: this.search
      }).then(response => {
        if (!response.success) {
          this.error = true
          return
        }
        this.loading = false
        this.search.limit = response.data.limit
        this.search.page = response.data.page + 1
        response.data.rows.forEach(item => {
          this.list.push(item)
        })
        if (response.data.rows.length < this.search.limit) {
          this.finished = true
        }
      })
    }
  }
}
</script>
<style scoped>
.dataRect .dataLine{
  border-bottom:1px solid #f5f5f5;
  padding: 0.5em 1em;
  min-height: 7.5em;
  background-color: #fff;
  position: relative;
}
.dataRect .dataLine .imgs{
  position: absolute;
  left: 1em;
  top: 0.6em;
}
.dataRect .dataLine .body{
  padding-left: 6.5em;
}
.dataRect .dataLine .body .title{
  font-size: 0.9em;
  font-weight: 700;
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.dataRect .dataLine .body .tags{
  font-size: 0.8em;
  line-height: 1.8em;
}
.dataRect .dataLine .body .tags span{
  margin-right: 0.5em;
  margin-bottom: 0.5em;
}
.dataRect .dataLine .body .remark{
  font-size: 0.8em;
  line-height: 1.8em;
  color: #000;
}
.dataRect .dataLine .body .remark span{
  font-weight: 700;
  color: #999;
}
.dataRect .dataLine .price{
  font-size: 1.2em;
  text-align: center;
}
.dataRect .dataLine .price span{
  font-size: 0.5em;
}

.newRect{
  padding: 2em 0;
  line-height: 1.8em;
  text-align: center;
  color: #000;
  background-color: #fff;
  border-bottom:1px solid #f5f5f5;
}
.newRect .remark{
  line-height: 1em;
  font-size: 0.8em;
  color: #999;
}
.newRect i{
  margin-right: 0.5em;
}
</style>
